module.exports = __webpack_public_path__ + "static/media/datasheet_topScorerData_row1_certificate1.74b3939e.png";